import {defineStore} from "pinia"
import {ref} from "vue"

import {useApi} from "@shared/composables/useApi"

export const useGameDetailStore = defineStore('GameDetailStore', () => {

    const {apiGet} = useApi()

    const isGameDetailFetched = ref(false)
    const game = ref({})

    const fetchGameDetail = async (gameCode) => {
        try {
            const {data} = await apiGet(`/api/games/${gameCode}`, {isSilent: false})
            game.value = data.game
            isGameDetailFetched.value = true
        } catch (e) {
            console.warn(e)
        }
    }

    return {
        isGameDetailFetched,
        fetchGameDetail,
        game,
    }
})
